import { render, staticRenderFns } from "./ClientPortalDrawer.vue?vue&type=template&id=affd5024&scoped=true&"
import script from "./ClientPortalDrawer.vue?vue&type=script&lang=js&"
export * from "./ClientPortalDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ClientPortalDrawer.vue?vue&type=style&index=0&id=affd5024&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affd5024",
  null
  
)

export default component.exports